export const PHOTO_EDIT_TYPES = {
  REMOVE_BACKGROUND: "REMOVE_BACKGROUND",
  CHANGE_PHOTO: "CHANGE_PHOTO",
  EXPAND_IMAGE: "EXPAND_IMAGE",
} as const;

export type PhotoEditType = keyof typeof PHOTO_EDIT_TYPES;
